import { DataConnection } from './dataConnection';
import { WorkflowImport } from './workflowImport';
import { Worker } from './worker';
import { BaseModel } from './basemodel';

export enum JobStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
}

export interface Job extends BaseModel {
  name: string;
  data: { [key: string]: unknown }[];
  result: { [key: string]: unknown }[];
  status: JobStatus;
  queueDate: number;
  priorityDate: number;
  priority: number;
  dataConnection?: DataConnection;
  workflowImport?: WorkflowImport;
  lastWorker: Worker;
}
